// @ts-strict-ignore
import isArray from 'lodash/isArray';

import {ChartType, ChartTypeDisplayNameKey} from 'common/report/constants';
import {LiftType, LiftTypeOverrides} from 'common/report/util/lift/types';
import {disableLiftTypeForChart} from 'common/report/util/lift';

function disableLineOrBarIfStacked(chartType: ChartType, {isStacked}: {isStacked: boolean}): LiftTypeOverrides {
  if (isStacked) {
    const reason = ({t}) => t(`reports.chart-types.labels.stacked`, {chartType: t(ChartTypeDisplayNameKey[chartType])});

    return {
      [LiftType.Segment]: disableLiftTypeForChart(LiftType.Segment, chartType, reason),
      [LiftType.Time]: disableLiftTypeForChart(LiftType.Time, chartType, reason),
    };
  }
  return {};
}

type LiftOverrideFunc = (chartType: ChartType, opts: any) => LiftTypeOverrides;

const DISABLEMENT_MAP: Partial<Record<ChartType, LiftType[] | LiftOverrideFunc>> = {
  [ChartType.Pie]: [LiftType.Segment, LiftType.Overall],
  [ChartType.Line]: disableLineOrBarIfStacked,
  [ChartType.Column]: disableLineOrBarIfStacked,
  [ChartType.Bar]: disableLineOrBarIfStacked,
  [ChartType.FunnelSteps]: [LiftType.Overall],
  [ChartType.FunnelTrend]: [LiftType.Overall],
  [ChartType.FunnelMedianTTC]: [LiftType.Segment, LiftType.Overall, LiftType.Time],
  [ChartType.Frequency]: [LiftType.Segment, LiftType.Overall, LiftType.Time],
  [ChartType.FunnelTopPaths]: [LiftType.Segment, LiftType.Overall, LiftType.Time],
};

export function getLiftTypeOverrides(
  chartType: ChartType,
  {
    isStacked,
  }: {
    isStacked: boolean;
  } = {
    isStacked: false,
  },
): LiftTypeOverrides {
  const disabled: LiftType[] | LiftOverrideFunc = DISABLEMENT_MAP[chartType];

  if (!disabled) {
    return {};
  }

  if (isArray(disabled)) {
    const overrides = {};

    for (const d of disabled) {
      overrides[d] = disableLiftTypeForChart(d, chartType);
    }

    return overrides;
  }

  return disabled(chartType, {isStacked});
}
